import client from './main-client';

export const sendFollowUpEmailApi = (data) => (
  client().post('/follow-up-email', data)
);
